import React, { useEffect, useState } from "react";
import { Wifi, WifiOff } from "lucide-react";
import { getPendingScans } from "../lib/idb";

export default function OfflineIndicator() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);

  useEffect(() => {
    const upd = () => setOnline(navigator.onLine);
    window.addEventListener("online", upd);
    window.addEventListener("offline", upd);
    const tick = async () => setPending((await getPendingScans()).length);
    tick();
    const id = setInterval(tick, 3000);
    return () => {
      window.removeEventListener("online", upd);
      window.removeEventListener("offline", upd);
      clearInterval(id);
    };
  }, []);

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-md text-xs font-semibold tracking-wide border ${
        online
          ? "border-[#05126E]/30 bg-[#E6E9F5] text-[#05126E]"
          : "border-[#C9A227]/40 bg-[#FFF8E1] text-[#7a5b00] animate-pulse"
      }`}
      data-testid="offline-indicator"
    >
      {online ? <Wifi className="w-3.5 h-3.5" /> : <WifiOff className="w-3.5 h-3.5" />}
      <span data-testid="connection-state">{online ? "Online" : "Offline"}</span>
      {pending > 0 && (
        <span
          className="ml-1 px-1.5 py-0.5 rounded bg-[#0f1a14] text-white text-[10px]"
          data-testid="pending-count"
        >
          {pending} pending
        </span>
      )}
    </div>
  );
}
